// When a Shell page transition fails (network error, 4xx, 5xx), Matestack emits
// page_loading_error and leaves the page dimmed with its loading state set.
// Turn that into a full navigation to the URL the user asked for, so they see
// the real error page or the sign-in redirect instead of a stuck page.
//
// The hub is passed in (matestack_patches.js supplies Matestack's own event
// hub) so this file has no bare imports and can be tested under Node.
//
// Only the newest request counts: if an earlier click fails while a later one
// is in flight or has rendered, the failure is stale and is ignored. Pages
// without a Shell (marked data-ds-shell) are left alone.
export function installShellPageLoading(hub, win = window, doc = document) {
  let latestUrl = null;

  hub.$on("page_loading", (url) => { latestUrl = url; });

  hub.$on("page_loading_error", (error) => {
    const target = error?.config?.url ?? latestUrl;
    if (!target || target !== latestUrl) return;
    if (!doc.querySelector("[data-ds-shell]")) return;
    win.location.assign(target);
  });
}
